import React from "react";
import { Link } from "react-router-dom";
import logoSrc from "../assets/logo.png";

const SIZES = {
  sm: { height: "auto", maxWidth: 160 },
  md: { height: "auto", maxWidth: 350 },
  lg: { height: "auto", maxWidth: 280 },
  xl: { height: "auto", maxWidth: 340 },
  hero: { height: "auto", maxWidth: 400 },
};

export default function BrandLogo({ to = "/", className = "", size = "md", testid }) {
  const { height, maxWidth } = SIZES[size] || SIZES.md;
  const img = (
    <img
      src={logoSrc}
      alt="VastraKiran — SaaS for boutiques"
      style={{ height, maxWidth, width: "auto" }}
      className="object-contain object-left"
    />
  );

  if (!to) {
    return <span className={`inline-flex items-center ${className}`}>{img}</span>;
  }

  return (
    <Link to={to} className={`inline-flex items-center ${className}`} data-testid={testid}>
      {img}
    </Link>
  );
}
